/** Build the public checker cards from the admissions register response. */
export function buildDeadlinePresets({ exams, cycle }) {
  const entryYear = cycle.split('-')[1];
  const uatFee = exam => `${exam.fees.uk_ireland} UK/IE (${exam.fees.international} Int)`;
  const tara = exams.tara;
  const esat = exams.esat;
  const lnat = exams.lnat;
  const ucat = exams.ucat;
  const groups = Object.fromEntries(lnat.deadline_groups.map(group => [group.group_name, group]));
  const london = groups['London Top-Tier Group'];
  const bristolDurham = groups['Mid-January Group'];
  const octoberTara = tara.sittings[0];
  const octoberEsat = esat.sittings[0];
  const uc = ucat.cycle_timeline;

  return [
    {
      university: 'University of Oxford',
      course: 'Economics & Management (E&M)',
      exam: 'TARA',
      examTitle: `${tara.name} (${tara.badge})`,
      deadline: octoberTara.booking_deadline,
      sitWindow: octoberTara.test_dates,
      fee: uatFee(tara),
      notes: 'Oxford applicants use the October sitting. Check the Oxford course page for its requirement.',
      status: `${entryYear} entry`,
      link: '/tara'
    },
    {
      university: 'University of Oxford',
      course: 'Philosophy, Politics & Economics (PPE)',
      exam: 'TARA',
      examTitle: `${tara.name} (${tara.badge})`,
      deadline: octoberTara.booking_deadline,
      sitWindow: octoberTara.test_dates,
      fee: uatFee(tara),
      notes: 'Oxford applicants use the October sitting. Check the Oxford course page for its requirement.',
      status: `${entryYear} entry`,
      link: '/tara'
    },
    {
      university: 'University of Cambridge',
      course: 'Engineering / Natural Sciences',
      exam: 'ESAT',
      examTitle: `${esat.name} (${esat.badge})`,
      deadline: octoberEsat.booking_deadline,
      sitWindow: octoberEsat.test_dates,
      fee: uatFee(esat),
      notes: 'Confirm the required ESAT modules on your university course page.',
      status: `${entryYear} entry`,
      link: '/esat'
    },
    {
      university: "King's College London / LSE / UCL",
      course: 'Law (LLB / BA Jurisprudence)',
      exam: 'LNAT',
      examTitle: `${lnat.name} (${london.group_name})`,
      deadline: london.register_and_book_deadline,
      sitWindow: `Must sit by ${london.sit_by_deadline}`,
      fee: `${lnat.fees.uk_eu} UK/EU (${lnat.fees.international} Int)`,
      notes: 'Book early to secure a suitable test slot.',
      status: `${entryYear} entry`,
      link: '/lnat'
    },
    {
      university: 'University of Bristol / Durham',
      course: 'Law (LLB)',
      exam: 'LNAT',
      examTitle: `${lnat.name} (${bristolDurham.group_name})`,
      deadline: bristolDurham.register_and_book_deadline,
      sitWindow: `Must sit by ${bristolDurham.sit_by_deadline}`,
      fee: `${lnat.fees.uk_eu} UK/EU (${lnat.fees.international} Int)`,
      notes: 'Bristol and Durham have an earlier LNAT deadline than most other providers.',
      status: `${entryYear} entry`,
      link: '/lnat'
    },
    {
      university: 'UK Medical Schools (All)',
      course: 'Medicine (MBBS / BMBS) & Dentistry',
      exam: 'UCAT',
      examTitle: ucat.name,
      deadline: uc.booking_deadline,
      sitWindow: uc.testing_window,
      fee: `${ucat.fees.uk} UK (${ucat.fees.international} Int)`,
      notes: ucat.format_changes_2025_onward,
      status: `${entryYear} entry`,
      link: '/ucat/format-2025-changes'
    }
  ];
}
